import Service from 'react-reservice';

import { EAqxTraderThemeMode, createTheme } from '@aquariuxfintech/aqx-trader-sdk-config/theme';

import { EAppThemeMode, EAppThemeScheme, IAppTheme } from '../types';

export interface IAppThemeContext {
  theme: IAppTheme;
  themeScheme: EAppThemeScheme;
}

const defaultContext: IAppThemeContext = {
  theme: {
    themeMode: EAppThemeMode.LIGHT,
    themeColors: createTheme({ themeMode: EAqxTraderThemeMode.LIGHT }).themeColors,
    fontFamily: 'IBM Plex Sans'
  },
  themeScheme: EAppThemeScheme.LIGHT_SCHEME
};

class AppThemeService extends Service<IAppThemeContext> {
  constructor() {
    super();
    this.context = defaultContext;
  }

  setThemeScheme = (nextThemeScheme: EAppThemeScheme) => {
    this.context.themeScheme = nextThemeScheme;
  };

  // When using this, always call createTheme first
  setThemeModeAndColors = (nextTheme: Pick<IAppTheme, 'themeMode' | 'themeColors'>) => {
    this.context.theme = {
      ...this.context.theme,
      ...nextTheme,
      themeColors: {
        ...nextTheme.themeColors
      }
    };
  };

  setPrimaryColor = (nextPrimaryColor: string) => {
    this.context.theme.themeColors.primary = nextPrimaryColor;
  };

  setFontFamily = (nextFontFamily: string) => {
    this.context.theme.fontFamily = nextFontFamily;
  };

  setCandlestickColors = (candlestick: { positive: string; negative: string }) => {
    this.context.theme.themeColors.candlestick.positive = candlestick.positive;
    this.context.theme.themeColors.candlestick.negative = candlestick.negative;
  };

  /** Getter */
  getThemeScheme = () => {
    return this.context.themeScheme;
  };

  getThemeColors = () => {
    return this.context.theme.themeColors;
  };
}

export const appThemeService = new AppThemeService();
